import { defineStore } from 'pinia';
import api from '@/services/api';
import {
  tipo_tratado_filters,
  tipo_tratado_model,
} from '../models/tipo_tratado_model';
import { getParamsUrl } from '../tipo_tratado_utils';

export const useTipoTratadoStore = defineStore('tipoTratadoStore', {
  state: () => ({
    entity: 'tipo-tratado',
    tipoTratados: [],
    tipoTratado: { ...tipo_tratado_model },
    page: 1,
    filters: {},
  }),
  getters: {},
  actions: {
    async findAllTipoTratadosHTTP(params) {
      const result = await api.get(
        `/${this.entity}?${getParamsUrl({ page: +this.page, ...this.filters, ...params })}`,
      );
      if (result && result.data.length > 0) {
        this.tipoTratados.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async findTipoTratadoHTTP(codigo) {
      const result = await api.get(`/${this.entity}/${codigo}`);
      if (result && result.data) {
        this.tipoTratado = result.data;
        return true;
      }
      return false;
    },
    async saveTipoTratado() {
      if (this.tipoTratado.Codigo) {
        return await this.updateTipoTratadoHTTP();
      } else {
        return await this.createTipoTratadoHTTP();
      }
    },
    async createTipoTratadoHTTP() {
      return await api.post(`/${this.entity}`, this.tipoTratado);
    },
    async updateTipoTratadoHTTP() {
      return await api.patch(`/${this.entity}/${this.tipoTratado.Codigo}`, this.tipoTratado);
    },
    async deleteTipoTratadoHTTP(tipoTratado) {
      return await api.patch(`/${this.entity}/${tipoTratado.Codigo}`, {
        ...tipoTratado,
        Activo: false,
      });
    },
    resetTipoTratado() {
      this.tipoTratado = { ...tipo_tratado_model };
    },
    resetFilters() {
      this.filters = { ...tipo_tratado_filters };
    },
    setPage(page) {
      this.page = page;
    },
    async firstTipoTratados() {
      this.setPage(1);
      this.emptyList();
      await this.findAllTipoTratadosHTTP();
    },
    emptyList() {
      this.tipoTratados = [];
    },
  },
});
